module.exports = {
	"articleTitle1": "Tomukun Korean Barbeque",
	"catImage": "greenstar.png",
	"totalCats": 1,
	"name": "Tomukun",
	"articleLink1": "#",
	"articleLink2": "https://www.michigandaily.com/arts/tomukun-bbq-0",
	"articleSnippet1": "Apr 10, 2015 ... Good thing I made a reservation to go to Tomukun Korean Barbeque on a \nSaturday night, because the line was out the door. To me, a long line ...",
	"articleSnippet2": "Jun 4, 2014 ... I first went to Tomukun Korean Barbecue at the beginning of May, only a week or \ntwo after it opened. The restaurant is adjacent to its wildly ...",
	"foodRecommendations": [],
	"articleTitle2": "Tomukun Korean Barbecue a delicious, intense new restaurant",
	"address": "505 E Liberty St #200, Ann Arbor, MI 48104",
	"images": [],
	"position": {
		"lat": 42.27955,
		"lng": -83.7429
	},
	"totalMisc": 1,
	"categories": {
		"bestofaa": 1,
		"fooddrink": 1,
		"location": 1,
		"restaurant": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/tomukun.json
// module id = 989
// module chunks = 0